import { render, staticRenderFns } from "./plugin-procedure-document.vue?vue&type=template&id=6b6ab2af&scoped=true&"
import script from "./plugin-procedure-document.vue?vue&type=script&lang=js&"
export * from "./plugin-procedure-document.vue?vue&type=script&lang=js&"
import style0 from "./plugin-procedure-document.vue?vue&type=style&index=0&id=6b6ab2af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ab2af",
  null
  
)

export default component.exports